import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Table from 'components/Table';
import structure from './structure';
import useI18n from 'i18n/useI18n';
import { useAlert } from '@etiquette-ui/alert-dialog';
import useInactive86 from 'state/inactive86';
import useProducts from 'state/products';
import { useSearch } from 'providers/search';
import { compareStrings } from 'utils';

const TableContainer = styled.div`
    flex: 1;
`;

const VerificationTable = () => {
    const { translate } = useI18n();
    const alert = useAlert();
    const [data] = useInactive86();
    const [products, productsDispatcher] = useProducts();
    const { search } = useSearch();
    const [list, setList] = useState([]);

    useEffect(() => {
        const newList = data.list.filter(
            ({ translations, why }) =>
                compareStrings(why ?? '', search) ||
                Object.values(translations).some(
                    ({ title, description }) => compareStrings(title ?? '', search) || compareStrings(description ?? '', search)
                )
        );
        setList(newList);
    }, [data.list, search]);

    return (
        <TableContainer>
            <Table
                structure={structure}
                config={{
                    translate,
                    productsDispatcher,
                    alert,
                    fetching: products.fetching,
                }}
                items={list}
            />
        </TableContainer>
    );
};

export default VerificationTable;
